import { Link } from "react-router-dom";
import { BedDouble, Car, Compass, Crown, Home, Luggage, Map, MapPin, UtensilsCrossed } from "lucide-react";
import { useLang } from "@/i18n";
import { Logo } from "../Logo";

/* Menu laterale del Concierge (solo desktop): navigazione reale del sito,
 * nessuna voce decorativa. */
export const ConciergeSidebar = ({ onRestaurants }) => {
    const { t } = useLang();
    const tc = t.concierge;
    const items = [
        { to: "/", icon: Home, label: t.nav.home, id: "home" },
        { to: "/concierge", icon: Crown, label: tc.fab, id: "concierge", active: true },
        { to: "/esperienze", icon: Compass, label: t.nav.experiences, id: "experiences" },
        { to: "/itinerari", icon: Map, label: t.nav.itineraries, id: "itineraries" },
        { to: "/alloggi", icon: BedDouble, label: t.nav.stays, id: "stays" },
        { to: "/transfer", icon: Car, label: t.nav.transfers, id: "transfers" },
        { action: onRestaurants, icon: UtensilsCrossed, label: tc.restaurants, id: "restaurants" },
        { to: "/", icon: MapPin, label: t.nav.destinations, id: "destinations" },
        { to: "/stato-prenotazione", icon: Luggage, label: tc.myTrips, id: "mytrips" },
    ];
    return (
        <aside data-testid="concierge-sidebar"
            className="sticky top-24 hidden max-h-[calc(100vh-7rem)] w-60 shrink-0 flex-col self-start rounded-2xl border border-amber-500/15 bg-[#0a0a0b]/85 p-5 lg:flex">
            <Logo />
            <nav className="mt-7 flex-1 space-y-1 overflow-y-auto">
                {items.map((it) => {
                    const cls = `flex w-full items-center gap-3 rounded-xl px-3.5 py-2.5 text-left text-[13px] transition-colors ${it.active
                        ? "border border-amber-400/50 bg-amber-400/10 font-semibold text-amber-200"
                        : "text-stone-400 hover:bg-white/5 hover:text-amber-100"}`;
                    const inner = (<><it.icon size={15} className={it.active ? "text-amber-300" : "text-amber-500/60"} />{it.label}</>);
                    return it.to ? (
                        <Link key={it.id} to={it.to} data-testid={`concierge-nav-${it.id}`} className={cls}>{inner}</Link>
                    ) : (
                        <button key={it.id} type="button" onClick={it.action} data-testid={`concierge-nav-${it.id}`} className={cls}>{inner}</button>
                    );
                })}
            </nav>
            <div className="mt-6 border-t border-amber-500/10 pt-5 text-center">
                <svg width="44" height="44" viewBox="0 0 64 64" className="mx-auto opacity-70" aria-hidden="true">
                    <circle cx="32" cy="32" r="26" fill="none" stroke="#D4AF37" strokeWidth="1" opacity="0.5" />
                    <circle cx="32" cy="32" r="19" fill="none" stroke="#D4AF37" strokeWidth="0.8" opacity="0.35" />
                    <path d="M32 10 L36 32 L32 54 L28 32 Z" fill="#D4AF37" opacity="0.85" />
                    <path d="M10 32 L32 28 L54 32 L32 36 Z" fill="#D4AF37" opacity="0.45" />
                    <circle cx="32" cy="32" r="3" fill="#F1D36C" />
                </svg>
                <p className="mt-3 font-display text-[12px] italic leading-relaxed text-amber-100/80">{tc.sidebarQuote}</p>
                <p className="mt-2 text-[9px] uppercase tracking-[0.3em] text-amber-500/70">Tourvoyagers</p>
            </div>
        </aside>
    );
};
